import { render, staticRenderFns } from "./addBusinessOpportunity.vue?vue&type=template&id=5b00c8d2&scoped=true"
import script from "./addBusinessOpportunity.vue?vue&type=script&lang=js"
export * from "./addBusinessOpportunity.vue?vue&type=script&lang=js"
import style0 from "./addBusinessOpportunity.vue?vue&type=style&index=0&id=5b00c8d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00c8d2",
  null
  
)

export default component.exports